export const routes = {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password/:resetToken',
    RESET_PASSWORD_PAGE: '/reset-password',
    INVESTMENTS: '/investments',
    PRODUCTS: '/products',
    PRODUCT_DETAIL: '/products/details',
    TRANSACTIONS: '/transactions',
    ACCOUNTS: '/accounts',
    PROFILE: '/profile',
    CONTACT: '/contact',
    NOT_FOUND:"not-found"

}

export const tracRoutes = [
  {page: 'my_investments', route: routes.INVESTMENTS},
  {page: 'product_details', route: routes.PRODUCT_DETAIL},
  {page: 'my_products', route: routes.PRODUCTS},
  {page: 'my_transactions', route: routes.TRANSACTIONS},
  {page: 'sign_in', route: routes.LOGIN},
  {page: 'password_forgotten', route: routes.FORGOT_PASSWORD},
  {page: 'password_reset_input', route: routes.RESET_PASSWORD_PAGE},
  {page: 'my_community', route: routes.ACCOUNTS},
  {page: 'not_found', route: routes.NOT_FOUND}
]